import { gql } from "@apollo/client";
import { useLazyQuery, useMutation } from "@apollo/client/react";
import { DSCircularButton } from "@components/design-system/molecules";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { useLocation } from "react-router";

import MARK_NOTES_EXPORTED from "../../../graphql/mutations/MarkNotesExported";
import { alert } from "../../common/Alert";
import { useNoteDownload } from "../../common/clinical/NotePDF";

export const GET_HEADER_INFO = gql`
  query noteUserInfo($uuid: String) {
    note(uuid: $uuid) {
      uuid
      user {
        uuid
        firstName
        lastName
        roleId
        account {
          uuid
          logoFileLink
          headerInfoPdf
        }
      }
    }
  }
`;

function ExportToPDF({
  note,
  patient,
  user = null,
  refetch = null,
  activeTab,
}) {
  const [getHeaderInfo] = useLazyQuery(GET_HEADER_INFO);
  const [modifyNotes] = useMutation(MARK_NOTES_EXPORTED);
  const location = useLocation();
  const [isCooldown, setIsCooldown] = useState(false);
  const { downloadNote } = useNoteDownload();

  const handleClick = async () => {
    if (isCooldown) {
      return;
    }
    setIsCooldown(true);

    setTimeout(() => {
      setIsCooldown(false);
    }, 5000);

    try {
      if (!user || !user?.account) {
        const { data } = await getHeaderInfo({
          variables: { uuid: note?.uuid },
        });
        try {
          await downloadNote(note, patient, data?.note?.user);
        } catch (response) {
          console.log(response);
        }
      } else {
        try {
          await downloadNote(note, patient, user);
        } catch (response) {
          console.log(response);
        }
      }
    } catch (e) {
      alert(
        "error",
        "An error has occurred. Please try again later.",
      );
      console.log(e);
      return;
    }

    try {
      await modifyNotes({
        variables: {
          noteUuids: [note.uuid],
          action: "mark_exported",
        },
      });
      alert(
        "info",
        `Check your browser's downloads for your note. ${
          note?.hasBeenExported
            ? ""
            : "Your note has now been marked as exported."
        }`,
      );
    } catch (e) {
      alert(
        "error",
        "Failed to mark the note as exported. Please try again later.",
      );
      console.log(e);
      return;
    }
    if (
      location.pathname === "/inbox" &&
      activeTab !== "exportedItems"
    ) {
      refetch();
    } else {
      if (refetch !== null) {
        refetch({ isApproved: true });
      }
    }
  };

  if (note) {
    const isDisabled =
      note?.isNewRecording ||
      note?.isMarkedAsProcessing ||
      note?.isMarkedAsFailed ||
      isCooldown;

    return (
      <DSCircularButton
        title="Download note as PDF"
        icon={faFileDownload}
        size="sm"
        variant="primary"
        disabled={isDisabled}
        onClick={handleClick}
        dataTestId="download-note-as-pdf-button"
      />
    );
  } else {
    return null;
  }
}

export default ExportToPDF;
